import { render } from "./RegisterNODRIZERSView.vue?vue&type=template&id=cc6d8326&scoped=true"
import script from "./RegisterNODRIZERSView.vue?vue&type=script&lang=js"
export * from "./RegisterNODRIZERSView.vue?vue&type=script&lang=js"

import "./RegisterNODRIZERSView.vue?vue&type=style&index=0&id=cc6d8326&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc6d8326"]])

export default __exports__